export default (path: string) => `/article${path}`;
